// Minimal JSON transport for public, non-secret reads/notices. Rejects when unavailable.
export async function fetchJSON(url, body) {
  if (typeof fetch !== "function") throw new Error("fetch unavailable");
  const response = await fetch(url, body === undefined ? {} : { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!response.ok) throw Object.assign(new Error("request failed"), { status: response.status });
  return response.json();
}
